// frontend/src/components/layout/AppLayout.jsx
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
// Supprimez l'import du Header
// import Header from '../common/Header';
import notificationSoundService from '../../services/notificationSoundService';

const AppLayout = () => {
  useEffect(() => {
    // Initialiser le service de son au démarrage de l'application
    notificationSoundService.initSoundService();
    
    // Précharger les sons au premier clic utilisateur pour contourner 
    // les restrictions de lecture automatique des navigateurs
    const handleInitialUserInteraction = () => {
      notificationSoundService.playNotificationSound('default');
      // Supprimer l'écouteur après le premier clic
      document.removeEventListener('click', handleInitialUserInteraction);
    };
    
    document.addEventListener('click', handleInitialUserInteraction);
    
    return () => {
      document.removeEventListener('click', handleInitialUserInteraction);
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Supprimez la ligne du Header */}
      <main className="flex-grow">
        <Outlet />
      </main>
    </div>
  );
};

export default AppLayout;